import * as React from 'react';
import * as _ from "lodash";
import { GeneralContainer, LinkSection,  Row, ColumnHeader, DepartmentName, LocationSelect, DrawerContainer, DrawerOptionsContainer, DrawerList, LocationPicker, SaveButton, IconWrapper, Explanation, Tools } from './styles';
import { ListingType } from "features/Dealers/Listings/state/types";


export const DepartmentsHeaders = (props) => {

    return (
        <>
            { renderHeaders()}
        </>
    )

    function renderHeaders() {
        if (props.renderType >= 3)
            return (
                <Row>
                    <ColumnHeader>
                        CMS Departments
                    </ColumnHeader>
                    <ColumnHeader>
                        Locations
                    </ColumnHeader>
                </Row>
            )
    }


}